const doc = [({"ko":({"adminConstantCompanyStatus":({"contract":"계약 중", "contractTerminated":"계약 종료", "contractTerminationScheduled":"계약 종료 예정", "preoperationalEnd":"조작전말"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;